import React from "react";
import { API } from "@/lib/api";

export const PRESET_AVATARS = [
  { id: "preset:1", from: "#60a5fa", to: "#1e3a8a" },
  { id: "preset:2", from: "#38bdf8", to: "#0e7490" },
  { id: "preset:3", from: "#818cf8", to: "#1e40af" },
  { id: "preset:4", from: "#34d399", to: "#065f46" },
  { id: "preset:5", from: "#fbbf24", to: "#92400e" },
  { id: "preset:6", from: "#f472b6", to: "#831843" },
  { id: "preset:7", from: "#a3a3a3", to: "#27272a" },
  { id: "preset:8", from: "#f87171", to: "#7f1d1d" },
];

export function presetGradient(id) {
  return PRESET_AVATARS.find((p) => p.id === id);
}

export default function Avatar({ user, size = 36, className = "" }) {
  const picture = user?.picture;
  const initial = user?.name?.[0]?.toUpperCase() || "U";
  const style = { width: size, height: size };

  if (picture?.startsWith("preset:")) {
    const g = presetGradient(picture);
    return (
      <div className={`rounded-lg flex items-center justify-center text-white font-semibold shrink-0 ${className}`}
        style={{ ...style, background: g ? `linear-gradient(135deg, ${g.from}, ${g.to})` : undefined, fontSize: size * 0.42 }}>
        {initial}
      </div>
    );
  }
  if (picture) {
    const token = localStorage.getItem("crm_token");
    const src = picture.startsWith("http") ? picture : `${API}/files/${picture}?auth=${token}`;
    return <img src={src} alt="" className={`rounded-lg object-cover shrink-0 ${className}`} style={style} />;
  }
  return (
    <div className={`rounded-lg flex items-center justify-center bg-blue-500/15 text-blue-300 font-semibold border border-blue-500/20 shrink-0 ${className}`}
      style={{ ...style, fontSize: size * 0.42 }}>
      {initial}
    </div>
  );
}
